// utils/socket.js
import { io } from 'socket.io-client';

// Get the backend URL from environment or default to localhost
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

// Create Socket.IO client instance
export const socket = io(SOCKET_URL, {
  withCredentials: true,
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1500,
});

// Connection event handlers
socket.on('connect', () => {
  console.log('🟢 Connected to HRMS Socket.IO server:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('🔴 HRMS Socket disconnected:', reason);
});

socket.on('connect_error', (error) => {
  console.error('❌ HRMS Socket connection error:', error);
});

// Reconnection event handlers
socket.on('reconnect', (attemptNumber) => {
  console.log('🔄 HRMS Socket reconnected after', attemptNumber, 'attempts');
});

socket.on('reconnect_attempt', (attemptNumber) => {
  console.log('🔄 HRMS Socket reconnection attempt:', attemptNumber);
});

socket.on('reconnect_error', (error) => {
  console.error('❌ HRMS Socket reconnection error:', error);
});

socket.on('reconnect_failed', () => {
  console.error('❌ HRMS Socket reconnection failed');
});

// Helper function to register user for notifications
export const registerUser = (userEmail) => {
  if (socket.connected && userEmail) {
    socket.emit('register', userEmail);
    console.log('👤 HRMS User registered for notifications:', userEmail);
  } else {
    console.warn('⚠️ Cannot register user - socket not connected or email missing');
  }
};

// Custom hook for using socket in components
export const useSocket = () => {
  return socket;
};

// Helper function to join user room when socket connects
socket.on('connect', () => {
  // Get user email from localStorage or context
  const userEmail = localStorage.getItem('userEmail') || sessionStorage.getItem('userEmail');
  if (userEmail) {
    registerUser(userEmail);
  }
});

export default socket;